<div *ngIf="loading" class="loading">
    <myapp-loading></myapp-loading>
</div>

<div *ngIf="!loading" class="info">
    <myapp-org-header [album]="album" [showLogo]="false"></myapp-org-header>

    <div class="photo-breadcrumbs">
        <div>
            <span class="photo-breadcrumb" (click)="onBackToGalleryClicked()">Back to Gallery</span>
            <span class="photo-breadcrumb" (click)="onBackToAlbumClicked()">Back to Album</span>
        </div>
        <div class="arrow-buttons">
            <p-button icon="fa fa-arrow-left" [rounded]="true" styleClass="arrow-button" (click)="onNavigatePrevious()" [disabled]="currentPhotoIndex === 0"></p-button>
            <p-button icon="fa fa-arrow-right" [rounded]="true" styleClass="arrow-button" (click)="onNavigateNext()" [disabled]="currentPhotoIndex === album.ImageAssets.length - 1"></p-button>
        </div>
    </div>

    <div class="center-area">
        <div class="top-area">
            <div class="caption">{{album.ImageAssets[currentPhotoIndex].Caption}}</div>
            <div class="buttons">
                <i *ngIf="isMember" class="favorite-button fa fa-heart" [class.favorite]="isFavorite" (click)="onFavoriteClicked()"></i>
                <button class="download-button" type="button" (click)="onDownloadImage()"
                        [disabled]="album.ImageAssets[currentPhotoIndex].AssetType !== AssetType.Image"><i class="fa fa-fw fa-download"></i></button>
            </div>
        </div>
        <div class="image" [@largeImageTrigger]="largeImageState">
            <myapp-image-asset *ngIf="album.ImageAssets[currentPhotoIndex].AssetType === AssetType.Image" class="image"
                               [imageAsset]="album.ImageAssets[currentPhotoIndex]" [width]="0" [height]="0" [usePlaceholder]="true"
                               [useBorder]="false" [scaleToFitContainer]="true"></myapp-image-asset>
            <iframe *ngIf="album.ImageAssets[currentPhotoIndex].AssetType === AssetType.Video" [src]="getSafeVideoUrlForCurrentImage" width="100%" height="100%" frameBorder="0"></iframe>
        </div>
        <div class="image-info">
            <div>Uploaded by: {{album.ImageAssets[currentPhotoIndex].uploadedBy}}</div>
            <div class="text-center">{{currentPhotoIndex + 1}} of {{album.ImageAssets.length}}</div>
            <div class="text-right">Added on: {{album.ImageAssets[currentPhotoIndex].CreatedOn | date}}</div>
        </div>
    </div>

    <div #carouselContainer class="carousel">
        <p-carousel #carousel [value]="album?.ImageAssets" [numVisible]="numberOfImagesThatFitInCarousel" [numScroll]="numberOfImagesToScroll">
            <ng-template pTemplate="item" let-image>
                <div class="carousel-image" (click)="onImageClicked(image)" [class.selected]="image == album.ImageAssets[currentPhotoIndex]">
                    <div class="thumbnail" [ngStyle]="{ 'background-image': 'url(' + image.getUrlForSize(96, 96, true) + ')'}"></div>
                </div>
            </ng-template>
        </p-carousel>
    </div>
</div>
